import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesComponent } from './pages.component';
import { InicioComponent } from './inicio/inicio.component';
import { Error404Component } from './error404/error404.component';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SharedModule } from '../shared/shared.module';
import { MaterialModuleModule } from '../material-module/material-module.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TablesModule } from '../components/tables/tables.module';
import { CrearOrdenComponent } from './transacciones/crear-orden/crear-orden.component';
import { OrdenesComponent } from './transacciones/ordenes/ordenes.component';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import {DataTablesModule} from 'angular-datatables';
import { EditarOrdenComponent } from './transacciones/editar-orden/editar-orden.component';
import { FacturarOrdenComponent } from './transacciones/facturar-orden/facturar-orden.component';
import { AnadirImagenesComponent } from './transacciones/anadir-imagenes/anadir-imagenes.component';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { EditarOrdenesImagenesComponent } from './transacciones/editar-ordenes-imagenes/editar-ordenes-imagenes.component';
import { CrearOrdenPaqueteComponent } from './transacciones/crear-orden-paquete/crear-orden-paquete.component';
import { Error500Component } from './errores/error500/error500.component';
import { CrearOrdenFisicaComponent } from './transacciones/crear-orden-fisica/crear-orden-fisica.component';
import { RequerimientosComponent } from './requerimientos/requerimientos.component';
import { CrearOrdenSfComponent } from './transacciones/crear-orden-sf/crear-orden-sf.component';
import { CrearOrdenFisicaSfComponent } from './transacciones/crear-orden-fisica-sf/crear-orden-fisica-sf.component';
import { SubirImagenesEcografiaComponent } from './transacciones/subir-imagenes-ecografia/subir-imagenes-ecografia.component';
import { EcografiaComponent } from './ecografia/ecografia.component';
import { SubirImagenesTomografiaComponent } from './transacciones/subir-imagenes-tomografia/subir-imagenes-tomografia.component';
import { SubirImagenesPeriapicalComponent,SafeUrlPipe } from './transacciones/subir-imagenes-periapical/subir-imagenes-periapical.component';
import { SubirImagenesPanoramicaComponent } from './transacciones/subir-imagenes-panoramica/subir-imagenes-panoramica.component';
import { PanoramicaComponent } from './panoramica/panoramica.component';
import { PeriapicalComponent } from './periapical/periapical.component';
import { TomografiasComponent } from './tomografias/tomografias.component';
import { SubirImagenesAnalisisComponent } from './transacciones/subir-imagenes-analisis/subir-imagenes-analisis.component';
import { AnalisisCefalometricoComponent } from './transacciones/analisis-cefalometrico/analisis-cefalometrico.component';
import { OrdenCitaPreviaComponent } from './transacciones/orden-cita-previa/orden-cita-previa.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { SubidaTomografiaComponent } from './transacciones/subida-tomografia/subida-tomografia.component';
import { CrearOrdenOfertaComponent } from './transacciones/crear-orden-oferta/crear-orden-oferta.component';
import { CorporalComponent } from './corporal/corporal.component';
import { SubirCorporalesComponent } from './subir-corporales/subir-corporales.component';
import { QuillModule } from 'ngx-quill';
import { CorporaalesDoctorComponent } from './corporaales-doctor/corporaales-doctor.component';
import { AnadirImgCorporalComponent } from './transacciones/anadir-img-corporal/anadir-img-corporal.component';
import { OrdenesFisicasSolicitudesComponent } from './transacciones/ordenes-fisicas-solicitudes/ordenes-fisicas-solicitudes.component';
import { OrdenesFisicasPreciosComponent } from './transacciones/ordenes-fisicas-precios/ordenes-fisicas-precios.component';
import { OrdenesFisicasTipoPreciosComponent } from './transacciones/ordenes-fisicas-tipo-precios/ordenes-fisicas-tipo-precios.component';
import { OrdenesFisicasNuevaSolicitudComponent } from './transacciones/ordenes-fisicas-nueva-solicitud/ordenes-fisicas-nueva-solicitud.component';
import { OrdenesFisicasSeguimientoBlocksComponent } from './transacciones/ordenes-fisicas-seguimiento-blocks/ordenes-fisicas-seguimiento-blocks.component';
import { PerfilesAccesoComponent } from './transacciones/perfiles-acceso/perfiles-acceso.component';
import { MiPerfilComponent } from './mi-perfil/mi-perfil.component';
import { UsuariosComponent } from './transacciones/usuarios/usuarios.component';
import { AdministracionSolicitudPreciosComponent } from './transacciones/administracion-solicitud-precios/administracion-solicitud-precios.component';
import { InformesRxComponent } from './informes-rx/informes-rx.component';
import { SubirInformeRxComponent } from './subir-informe-rx/subir-informe-rx.component';
import { SellosFirmasComponent } from './configuraciones/sellos-firmas/sellos-firmas.component';
import { AccesoIpComponent } from './seguridad/acceso-ip/acceso-ip.component';
import { LaboratoriosComponent } from './laboratorio/laboratorios/laboratorios.component';
import { ProveedoresDerivadosComponent } from './laboratorio/proveedores-derivados/proveedores-derivados.component';
import { InformacionPruebasComponent } from './laboratorio/informacion-pruebas/informacion-pruebas.component';
import { ResultadosLabComponent } from './laboratorio/resultados-lab/resultados-lab.component';
import { EstadosMuestrasComponent } from './laboratorio/estados-muestras/estados-muestras.component';
import { DescuentosComponent } from './transacciones/descuentos/descuentos.component';
import { CrearDescuentoComponent } from './transacciones/crear-descuento/crear-descuento.component';
import { DocumentosElectronicosComponent } from './transacciones/documentos-electronicos/documentos-electronicos.component';
import { CrearPaqueteComponent } from './transacciones/crear-paquete/crear-paquete.component';
import { NotasCreditoComponent } from './transacciones/notas-credito/notas-credito.component';
import { EnvioMasivoComponent } from './transacciones/envio-masivo/envio-masivo.component';
import { OrdenesConvenioComponent } from './transacciones/ordenes-convenio/ordenes-convenio.component';
import { CrearFacturaConvenioComponent } from './transacciones/crear-factura-convenio/crear-factura-convenio.component';
import { HistoriaClinicaComponent } from './gestion-clinica/historia-clinica/historia-clinica.component';
import { CrearHistoriaClinicaComponent } from './gestion-clinica/crear-historia-clinica/crear-historia-clinica.component';
import { HistorialPacienteComponent } from './gestion-clinica/historial-paciente/historial-paciente.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
   
    InicioComponent,
    Error404Component,
    CrearOrdenComponent,
    OrdenesComponent,
    EditarOrdenComponent,
    FacturarOrdenComponent,
    AnadirImagenesComponent,
    EditarOrdenesImagenesComponent,
    CrearOrdenPaqueteComponent,
    Error500Component,
    CrearOrdenFisicaComponent,
    RequerimientosComponent,
    CrearOrdenSfComponent,
    CrearOrdenFisicaSfComponent,
    SubirImagenesEcografiaComponent,
    EcografiaComponent,
    SubirImagenesTomografiaComponent,
    SubirImagenesPeriapicalComponent,
    SubirImagenesPanoramicaComponent,
    PanoramicaComponent,
    PeriapicalComponent,
    TomografiasComponent,
    SafeUrlPipe,
    SubirImagenesAnalisisComponent,
    AnalisisCefalometricoComponent,
    OrdenCitaPreviaComponent,
    SubidaTomografiaComponent,  
    CrearOrdenOfertaComponent,
    CorporalComponent,
    SubirCorporalesComponent,
    CorporaalesDoctorComponent,
    AnadirImgCorporalComponent,
    OrdenesFisicasSolicitudesComponent,
    OrdenesFisicasSeguimientoBlocksComponent,
    OrdenesFisicasNuevaSolicitudComponent,
    OrdenesFisicasPreciosComponent,
    OrdenesFisicasTipoPreciosComponent,
    PerfilesAccesoComponent,
    MiPerfilComponent,
    UsuariosComponent,
    AdministracionSolicitudPreciosComponent,
    InformesRxComponent,
    SubirInformeRxComponent,
    SellosFirmasComponent,
    AccesoIpComponent,
    LaboratoriosComponent,
    ProveedoresDerivadosComponent,
    InformacionPruebasComponent,
    ResultadosLabComponent,
    DescuentosComponent,
    CrearDescuentoComponent,
    DocumentosElectronicosComponent,
    NotasCreditoComponent,
    EnvioMasivoComponent,
    OrdenesConvenioComponent,
    CrearFacturaConvenioComponent,
    CrearPaqueteComponent,
    HistoriaClinicaComponent,
    CrearHistoriaClinicaComponent,
    HistorialPacienteComponent,
  ],
  exports:[

    RouterModule
    
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MaterialModuleModule,
    NgSelectModule,
    RouterModule,
    NgxDatatableModule,
    NgbModule,
    TablesModule,
    NgxMaskModule.forRoot(maskConfig),
    DataTablesModule,
    DropzoneModule,
    NgxDropzoneModule,
    FullCalendarModule,
    QuillModule,
    EstadosMuestrasComponent
  ],

  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
}) 
export class PagesModule { }
